export default "__VITE_ASSET__cba7f884__"